import Splide from "@splidejs/splide";

document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.cards-block');

  if (!slider) return;

  const splide = new Splide(slider, {
    type: 'loop',
    perPage: 1,
    gap: '1rem',
    padding: { right: '3rem' },
    arrows: false,
    pagination: false,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        destroy: true,
      }
    }
  });

  splide.mount();
});